<div class="container mt-4">
  <div class="card p-4 mb-4">
    <h5>Add New Customer</h5>
    <form (ngSubmit)="addCustomer()">
      <div class="row">
        <div class="col-md-4 mb-3">
          <label>Customer Short Code</label>
          <input
            type="text"
            [(ngModel)]="newCustomer.CustomerShortCode"
            name="customerShortCode"
            class="form-control"
            maxlength="45"
            required
          />
        </div>
        <div class="col-md-6 mb-3">
          <label>Customer Name</label>
          <input
            type="text"
            [(ngModel)]="newCustomer.CustomerName"
            name="customerName"
            class="form-control"
            maxlength="200"
            required
          />
        </div>
        <div class="col-md-2 mb-3 d-flex align-items-end">
          <button class="btn btn-primary w-100" type="submit">Add Customer</button>
        </div>
      </div>
    </form>
  </div>

  <div class="card p-3 mb-3">
    <div class="row">
      <div class="col-md-6">
        <label>Search</label>
        <input
          type="text"
          class="form-control"
          placeholder="Search by short code or name"
          [(ngModel)]="searchText"
          (ngModelChange)="onSearchChange()"
        />
      </div>
      <div class="col-md-6 d-flex align-items-end text-muted small">
        {{ filteredCustomers.length }} of {{ customerList.length }} customer(s)
      </div>
    </div>
  </div>

  <div class="card p-3">
    <h5>Customer List</h5>
    <p class="text-muted small mb-3">
      Set license pool, PPT branding, deck layout (size + master), and linked slide types per customer. SMEs are linked to a customer under Manage Users. Empty layout fields use defaults from server config (currently ENE 33.867×19.05 cm).
    </p>
    <div *ngIf="loading">Loading customers…</div>
    <div *ngIf="error" class="text-danger">{{ error }}</div>

    <table class="table table-bordered table-hover align-middle" *ngIf="!loading">
      <thead class="table-light">
        <tr>
          <th>
            <button type="button" class="btn btn-link p-0 text-decoration-none fw-semibold" (click)="setSort('CustomerShortCode')">
              Short Code{{ sortIndicator('CustomerShortCode') }}
            </button>
          </th>
          <th>
            <button type="button" class="btn btn-link p-0 text-decoration-none fw-semibold" (click)="setSort('CustomerName')">
              Customer Name{{ sortIndicator('CustomerName') }}
            </button>
          </th>
          <th>Licenses</th>
          <th>Slide types</th>
          <th>PPT branding &amp; layout</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let customer of filteredCustomers">
          <td>{{ customer.CustomerShortCode }}</td>
          <td>{{ customer.CustomerName }}</td>
          <td style="min-width: 16rem;">
            <div class="mb-2 small text-muted" *ngIf="customer.licensesUsed != null">
              Used {{ customer.licensesUsed }} / {{ customer.totalLicenses || 0 }}
              <span *ngIf="customer.licensesAvailable != null">({{ customer.licensesAvailable }} available)</span>
            </div>
            <div class="row g-2">
              <div class="col-6">
                <label class="form-label small mb-0">Total purchased</label>
                <input
                  type="number"
                  class="form-control form-control-sm"
                  min="0"
                  [(ngModel)]="licenseEdits[customer.CustomerShortCode].totalLicenses"
                  [name]="'lic_' + customer.CustomerShortCode"
                />
              </div>
              <div class="col-6">
                <label class="form-label small mb-0">Mode</label>
                <select
                  class="form-select form-select-sm"
                  [(ngModel)]="licenseEdits[customer.CustomerShortCode].licenseMode"
                  [name]="'mode_' + customer.CustomerShortCode"
                >
                  <option value="POOL">Pool (shared)</option>
                  <option value="ASSIGNED">Per-SME assigned</option>
                </select>
              </div>
            </div>
            <button
              type="button"
              class="btn btn-sm btn-outline-primary mt-2"
              [disabled]="savingLicense[customer.CustomerShortCode]"
              (click)="saveLicenses(customer)"
            >
              {{ savingLicense[customer.CustomerShortCode] ? 'Saving…' : 'Save licenses' }}
            </button>
          </td>
          <td style="min-width: 18rem;">
            <div class="small text-muted mb-2" *ngIf="customer.slideTypeCount != null">
              {{ customer.slideTypeCount }} linked
              <span *ngIf="customer.slideTypeCount === 0">(creator uses all layout-matching types)</span>
            </div>
            <div
              class="border rounded p-2 mb-2"
              style="max-height: 10rem; overflow-y: auto;"
              *ngIf="allSlideTypes.length; else noSlideTypes"
            >
              <label
                *ngFor="let st of allSlideTypes"
                class="d-block small mb-1"
                [class.text-muted]="isSlideTypeRemovalLocked(customer.CustomerShortCode, st.slideTypeShortcode)"
              >
                <input
                  type="checkbox"
                  class="form-check-input me-1"
                  [checked]="isSlideTypeSelected(customer.CustomerShortCode, st.slideTypeShortcode)"
                  [disabled]="isSlideTypeRemovalLocked(customer.CustomerShortCode, st.slideTypeShortcode)"
                  (change)="toggleSlideType(customer.CustomerShortCode, st.slideTypeShortcode, $event)"
                />
                <span class="fw-semibold">{{ st.slideTypeShortcode }}</span>
                <span *ngIf="st.slideTypeName"> — {{ st.slideTypeName }}</span>
                <span
                  *ngIf="isSlideTypeRemovalLocked(customer.CustomerShortCode, st.slideTypeShortcode)"
                  class="badge bg-secondary ms-1"
                  title="Used on project slides for this customer"
                >in use</span>
              </label>
            </div>
            <ng-template #noSlideTypes>
              <div class="small text-muted mb-2">No slide types defined in designer.</div>
            </ng-template>
            <button
              type="button"
              class="btn btn-sm btn-outline-primary"
              [disabled]="savingSlideTypes[customer.CustomerShortCode]"
              (click)="saveSlideTypes(customer)"
            >
              {{ savingSlideTypes[customer.CustomerShortCode] ? 'Saving…' : 'Save slide types' }}
            </button>
          </td>
          <td style="min-width: 16rem;">
            <div class="small text-muted mb-2 fw-semibold">Branding</div>
            <div class="small text-muted mb-1">BG: {{ customer.pptBackgroundFile || 'default' }}</div>
            <input
              type="file"
              class="form-control form-control-sm mb-2"
              accept="image/png,image/jpeg,image/webp"
              [disabled]="isUploading(customer.CustomerShortCode, 'background')"
              (change)="onBrandingFileSelected(customer, 'background', $event)"
            />
            <div class="small text-muted mb-1">Logo: {{ customer.pptLogoFile || 'default' }}</div>
            <input
              type="file"
              class="form-control form-control-sm mb-3"
              accept="image/png,image/jpeg,image/webp"
              [disabled]="isUploading(customer.CustomerShortCode, 'logo')"
              (change)="onBrandingFileSelected(customer, 'logo', $event)"
            />

            <div class="small text-muted mb-2 fw-semibold">Deck layout</div>
            <div class="mb-2" *ngIf="pptLayoutEdits[customer.CustomerShortCode] as layout">
              <label class="form-label small mb-0">Layout name</label>
              <input
                type="text"
                class="form-control form-control-sm mb-2"
                [(ngModel)]="layout.pptLayoutName"
                [name]="'pptLayoutName_' + customer.CustomerShortCode"
                placeholder="ENElayout"
              />
              <div class="row g-2 mb-2">
                <div class="col-6">
                  <label class="form-label small mb-0">Width (cm)</label>
                  <input
                    type="number"
                    class="form-control form-control-sm"
                    step="0.001"
                    min="0"
                    [(ngModel)]="layout.pptLayoutWidthCm"
                    [name]="'pptWidth_' + customer.CustomerShortCode"
                    placeholder="33.867"
                  />
                </div>
                <div class="col-6">
                  <label class="form-label small mb-0">Height (cm)</label>
                  <input
                    type="number"
                    class="form-control form-control-sm"
                    step="0.001"
                    min="0"
                    [(ngModel)]="layout.pptLayoutHeightCm"
                    [name]="'pptHeight_' + customer.CustomerShortCode"
                    placeholder="19.05"
                  />
                </div>
              </div>
              <label class="form-label small mb-0">Slide master name</label>
              <input
                type="text"
                class="form-control form-control-sm mb-2"
                [(ngModel)]="layout.pptSlideMasterName"
                [name]="'pptMaster_' + customer.CustomerShortCode"
                placeholder="ENENormal"
              />
              <button
                type="button"
                class="btn btn-sm btn-outline-primary"
                [disabled]="savingPptLayout[customer.CustomerShortCode]"
                (click)="savePptLayout(customer)"
              >
                {{ savingPptLayout[customer.CustomerShortCode] ? 'Saving…' : 'Save PPT layout' }}
              </button>
            </div>
          </td>
        </tr>
        <tr *ngIf="filteredCustomers.length === 0">
          <td colspan="5" class="text-muted text-center">No customers found.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
